export const InspectionAvailabilitySlotFragment = gql`
  fragment InspectionAvailabilitySlotFragment on InspectionAvailabilitySlot {
    startTime
    endTime
    durationMinutes
  }
`

export const InspectionAvailabilityDayFragment = gql`
  fragment InspectionAvailabilityDayFragment on InspectionAvailabilityDay {
    date
    holidayName
    slots {
      ...InspectionAvailabilitySlotFragment
    }
  }
`
